import { reset } from "redux-form";
import { serviceTaskManagementDetail } from "../services/ProviderUser.service";
import { serviceGetList } from "../services/index.services";

export const GET_TASK_DETAIL = 'GET_TASK_DETAIL';
export const SET_LIST_DATA = 'SET_LIST_DATA';
export const SET_LIST_LOADING = 'SET_LIST_LOADING';

export function actionTaskManagementDetail(taskId) {
    const request = serviceTaskManagementDetail({id: taskId});
    return (dispatch) => {
        dispatch({ type: GET_TASK_DETAIL, payload: null });
        request.then((res) => {
          
            if (!res?.error) {
                dispatch({ type: GET_TASK_DETAIL, payload: res.data })
            }
        })
    }
}

// Action to fetch list data (PRODUCTS, etc.)
export function actionFetchListData(keys = ["PRODUCTS"]) {
    return (dispatch, getState) => {
        const { lists } = getState().common;
        
        // Check if data already exists for all requested keys
        const needsToFetch = keys.some(key => !lists[key] || lists[key].length === 0);
        
        if (!needsToFetch) {
            // Data already exists, no need to fetch
            return Promise.resolve();
        }

        dispatch({ type: SET_LIST_LOADING, payload: true });
        
        const request = serviceGetList(keys);
        return request.then((res) => {
            if (!res?.error) {
                dispatch({ type: SET_LIST_DATA, payload: res.data });
            }
            dispatch({ type: SET_LIST_LOADING, payload: false });
            return res;
        }).catch((err) => {
            dispatch({ type: SET_LIST_LOADING, payload: false });
            return err;
        });
    };
}

// Combined action to fetch list data
export function actionFetchAllListData(listKeys = ["PRODUCTS"]) {
    return (dispatch) => {
        return dispatch(actionFetchListData(listKeys));
    };
}